import type { SignedReasonType, UnsignedReasonType } from "./types"

/** 亏损原因判定大项（可多选）：A 数据有问题 / B 项目操作原因 */
export const SIGNED_REASON_OPTIONS: { value: SignedReasonType; title: string; desc: string }[] = [
    { value: "A", title: "A. 数据有问题", desc: "工时/里程碑/立项口径等填报或数据源有误" },
    { value: "B", title: "B. 项目操作原因", desc: "品牌项目 / 非品牌项目经营性亏损" },
]

/** 亏损原因判定「选中大项」展示文案 */
export const SIGNED_REASON_LABEL: Record<SignedReasonType, string> = {
    A: "A. 数据有问题",
    B: "B. 项目操作原因",
}

/**
 * 归一化亏损原因判定多选值（spec 4.8 回填 / 只读预览共用）：
 *  - 新口径保存内容为 reasonTypes 多选数组；
 *  - 兼容历史单值保存内容 reasonType（"" / A / B）与非法值（过滤后返回）。
 */
export const normalizeSignedReasonTypes = (payload: unknown): SignedReasonType[] => {
    if (!payload || typeof payload !== "object") return []
    const raw = payload as { reasonTypes?: unknown; reasonType?: unknown }
    if (Array.isArray(raw.reasonTypes)) {
        const list = raw.reasonTypes.filter((v): v is SignedReasonType => v === "A" || v === "B")
        return Array.from(new Set(list))
    }
    if (raw.reasonType === "A" || raw.reasonType === "B") return [raw.reasonType]
    return []
}

/** 品牌项目专属原因 */
export const BRAND_REASON = {
    key: "B0",
    label: "品牌项目",
    desc: "和预计毛利率对比，低于毛利率需写原因；并描述止损边界与退出条件",
}

/** B 项内部：品牌项目 / 非品牌项目 二选一 */
export const B_CATEGORY_OPTIONS = [
    {
        value: "brand" as const,
        label: "B0 品牌项目",
        desc: "和预计毛利率对比，低于毛利率写原因；描述止损边界与退出条件",
    },
    {
        value: "non_brand" as const,
        label: "非品牌项目",
        desc: "勾选原因类别，每选一项必须填写该项专属描述",
    },
]

/** 非品牌项目（经营性亏损）原因类别 */
export const NON_BRAND_REASONS = [
    { key: "B1", label: "甲方原因" },
    { key: "B2", label: "团队管理原因" },
    { key: "B3", label: "政府政策/审批原因" },
    { key: "B4", label: "市场/投标报价原因" },
    { key: "B5", label: "分包方/合作方原因" },
    { key: "B6", label: "技术方案原因" },
    { key: "B7", label: "合同/回款原因" },
    { key: "B8", label: "其他原因" },
]

/** 数据有无问题（A）子项 */
export const DATA_ISSUE_ITEMS = [
    { key: "A1", label: "工时填报错误" },
    { key: "A2", label: "里程碑填报错误" },
    { key: "A3", label: "立项、口径或数据源有误" },
]

/** 未签约项目原因类型 */
export const UNSIGNED_REASONS: {
    value: UnsignedReasonType
    label: string
    desc: string
}[] = [
    { value: "wrong_initiation", label: "立项错误", desc: "实际已签约，重复立项" },
    { value: "data_error", label: "员工数据填错", desc: "错填人员，备注情况" },
    { value: "will_sign", label: "会签约", desc: "跟踪推进，提醒签约" },
    { value: "other", label: "其他原因", desc: "出了什么问题-事实+数据辅助" },
]

/** 商机状态可选值 */
export const OPPORTUNITY_STATUS_OPTIONS = [
    "线索",
    "商机",
    "投标中",
    "合同评审",
    "即将签约",
]

export const REVIEW_KIND_LABEL: Record<string, string> = {
    signed: "已签约项目复盘",
    unsigned: "未签约项目人力投入复盘",
}
